// 职位设置路由
export default [
  {
    //员工职位设置
    path: '/common/edit_positions_info',
    name: 'edit_positions_info',
    component: resolve => require(['@/views/common/editPositionsInfo.vue'], resolve)
  },
  {
    //DMS权限管理
    path: '/common/dms_power_set',
    name: 'dms_power_set',
    component: resolve => require(['@/views/common/powerSet.vue'], resolve)
  },
  {
    //DMS角色列表
    path: '/common/dms_roles_list',
    name: 'dms_roles_list',
    component: resolve => require(['@/views/common/roleList.vue'], resolve)
  },
  {
    //DMS员工权限设置
    path: '/common/dms_role_power_set',
    name: 'dms_role_power_set',
    component: resolve => require(['@/views/common/rolePowerSet.vue'], resolve)
  },
]



// WEBPACK FOOTER //
// ./src/router/routers/common.js